import { FormProvider, useForm } from 'react-hook-form';
import { FiX } from 'react-icons/fi';
import { usePreviewSurveyQuery } from '../../../../../api/financeApi';
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons, CTAButtonsAlt } from "../../../../../global/components/Buttons/buttons";
import { FormInput } from '../../../../Components/Forms/InputTemplate';
const SurveyModal = ({ handleSubmitSurvey, isLoading, setOpenSurveyModal, categoryType }) => {
  const { data } = usePreviewSurveyQuery(categoryType);
  const formMethods = useForm({
    mode: "all",
    defaultValues: {},
  });

  const { handleSubmit } = formMethods;

  // Handle form submission with survey data
  const onSubmit = (formData) => {
    handleSubmitSurvey(formData, data);
  };

  // Direct submission handler for testing
  const handleDirectSubmit = () => {
    const formData = formMethods.getValues();
    handleSubmitSurvey(formData, data);
  };

  // Render question based on type
  const renderQuestion = (question) => {
    const { id, questionText, questionType, isRequired, displayOrder, characterLimit, ratingScaleMin, ratingScaleMax, options } = question;

    switch (questionType) {
      case 1: // Checkbox
        return (
          <div className='space-y-3'>
            <label className={DashboardStyle.input_title}>
              {questionText} {isRequired && <sup style={{ color: "red" }}>*</sup>}
            </label>
            {options.map((option) =>
              <div key={option.id} className='flex space-x-3 items-center'>
                <div >
                  <input
                    type="checkbox"
                    {...formMethods.register(`question_${id}_${option.id}`)}
                    value={option.id.toString()}
                    style={{ accentColor: "#5A7B53" }}
                  />
                </div>
                <div>
                  <p>{option.optionText}</p>
                </div>
              </div>)}
          </div>

        );

      case 2:
        return (
          <div className='space-y-3'>
            <label className={DashboardStyle.input_title}>
              {questionText} {isRequired && <sup style={{ color: "red" }}>*</sup>}
            </label>
            {options.map((option) =>
              <div key={option.id} className='flex space-x-3 items-center'>
                <div >
                  <input
                    type="radio"
                    {...formMethods.register(`question_${id}`, { required: isRequired })}
                    value={option.id}
                    className={DashboardStyle.checkbox_style}
                    style={{ accentColor: "#5A7B53" }}
                  />
                </div>
                <div>
                  <p>{option.optionText}</p>
                </div>
              </div>)}
          </div>
        );

      case 3: // Rating (Slider)
        return (
          <div key={id} className={DashboardStyle.input_container}>
            <label className={DashboardStyle.input_title}>
              {questionText} {isRequired && <sup style={{ color: "red" }}>*</sup>}
            </label>
            <div className="flex items-center space-x-4">
              <span className={DashboardStyle.input_title}>Poor</span>
              <input
                type="range"
                min={ratingScaleMin}
                max={ratingScaleMax}
                value={formMethods.watch(`question_${id}`) || ratingScaleMin}
                onChange={(e) => {
                  formMethods.setValue(`question_${id}`, parseInt(e.target.value));
                }}
                className="flex-1"
                style={{
                  accentColor: "#5A7B53",
                  background: `linear-gradient(to right, #5A7B53 0%, #5A7B53 ${((formMethods.watch(`question_${id}`) || ratingScaleMin) - ratingScaleMin) / (ratingScaleMax - ratingScaleMin) * 100}%, #E5E7EB ${((formMethods.watch(`question_${id}`) || ratingScaleMin) - ratingScaleMin) / (ratingScaleMax - ratingScaleMin) * 100}%, #E5E7EB 100%)`
                }}
              />
              <span className={DashboardStyle.input_title}>Excellent</span>
            </div>
            <div className="mt-3 space-x-6 flex items-center justify-center">
              {options.map((option) => (
                <div key={option.id}>
                  <CTAButtonsAlt
                    type="button"
                    hideIcon={true}
                    onClick={() => {
                      formMethods.setValue(`question_${id}`, option.displayOrder);
                    }}
                    className="text-sm"
                  >
                    {option.optionText}
                  </CTAButtonsAlt>
                </div>
              ))}
            </div>
          </div>
        );

      case 4: // Text
        return (
          <FormInput
            key={id}
            camelCase={`question_${id}`}
            title={questionText}
            isOptional={!isRequired}
            placeholder={`Enter ${questionText.toLowerCase()}`}
            maxLength={characterLimit}
          />
        );

      case 5: // Textarea
        return (
          <div key={id} className={DashboardStyle.input_container}>
            <label className={DashboardStyle.input_title}>
              {questionText} {isRequired && <sup style={{ color: "red" }}>*</sup>}
            </label>
            <textarea
              {...formMethods.register(`question_${id}`, { required: isRequired, maxLength: characterLimit })}
              placeholder={`Enter ${questionText.toLowerCase()}`}
              className={`${DashboardStyle.input_field} w-full h-32 p-2 border rounded`}
              maxLength={characterLimit}
            />
          </div>
        );

      default:
        return (
          <FormInput
            key={id}
            camelCase={`question_${id}`}
            title={questionText}
            isOptional={!isRequired}
          />
        );
    }
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Survey Questions</h4>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setOpenSurveyModal(false)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <div className={DashboardStyle.view_app_components}>
              <div className="space-y-6">
                {data?.questions?.map((question) => renderQuestion(question))}
              </div>
              <div style={{ marginTop: "1rem" }} className={DashboardStyle.button_cage}>
                <CTAButtons type="button" hideIcon={true} onClick={handleDirectSubmit}>
                  {isLoading ? "Submitting..." : "Submit Survey"}
                </CTAButtons>
              </div>
            </div>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};
export { SurveyModal };
